<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          :src="person_photo"
          transition="scale-transition"
          width="40"
        />
        <VToolbarTitle
          >ระบบรับสมัครงานออนไลน์{{
            this.$store.getters.userRegis
          }}</VToolbarTitle
        >
      </div>
      <v-spacer></v-spacer>
      <v-btn
        href="./downloads/Job_Form.pdf"
        download="Job_Form.pdf"
        color="success"
        class="mr-2"
      >
        <v-icon left>mdi-download</v-icon>
        Download เอกสารใบสมัครงาน
      </v-btn>
      <v-layout row justify-end mr3> <Signin></Signin> </v-layout>
      <v-checkbox
        class="d-none"
        inset
        @change="darkMode"
        off-icon="mdi-brightness-4"
        on-icon="mdi-brightness-5"
        color="dark"
      ></v-checkbox>
    </v-app-bar>
    <div class="bg_blur"></div>
    <v-main>
      <router-view></router-view>
      <loadingModal></loadingModal>
    </v-main>
  </v-app>
</template>

<script>
import loadingModal from "@/components/loading";
import Signin from "./views/signin.vue";
var imgLogo = require("@/assets/images/logo.gif");
export default {
  name: "App",

  components: {
    loadingModal,
    Signin,
  },

  data: () => ({
    text: "DarkMode Welcome",
    person_photo: imgLogo,
  }),
  mounted() {
    const theme = localStorage.getItem("dark_theme");
    if (theme === "true") {
      this.$vuetify.theme.dark = true;
    } else {
      this.$vuetify.theme.dark = false;
    }
  },
  methods: {
    darkMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("dark_theme", this.$vuetify.theme.dark.toString());
    },
  },
};
</script>

<style>
@font-face {
  font-family: "Sarabun";
  font-style: normal;
  font-weight: 400;
  src: url("./assets/fonts/sarabun-v8-thai-regular.eot");
  /* IE9 Compat Modes */
  src: local(""),
    url("./assets/fonts/sarabun-v8-thai-regular.eot?#iefix")
      format("embedded-opentype"),
    /* IE6-IE8 */ url("./assets/fonts/sarabun-v8-thai-regular.woff2")
      format("woff2"),
    /* Super Modern Browsers */
      url("./assets/fonts/sarabun-v8-thai-regular.woff") format("woff"),
    /* Modern Browsers */ url("./assets/fonts/sarabun-v8-thai-regular.ttf")
      format("truetype"),
    /* Safari, Android, iOS */
      url("./assets/fonts/sarabun-v8-thai-regular.svg#Sarabun") format("svg");
  /* Legacy iOS */
}

.fontMain,
* {
  font-family: "Sarabun", "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
}

li a {
  text-decoration: none;
}
.v-list-item__title {
  line-height: 1.5 !important;
}
.swal2-html-container {
  line-height: 2 !important;
}
.bg_blur {
  background-image: url("./assets/images/bg.jpg") !important;
  z-index: 0;
  position: fixed;
  left: 0;
  right: 0;
  display: block;
  margin-top: 0px;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 100%;
  min-width: 100%;
  -webkit-filter: blur(5px);
  -moz-filter: blur(5px);
  -o-filter: blur(5px);
  -ms-filter: blur(5px);
  filter: blur(5px);
}

.v-text-field input,
.v-input .v-label,
.v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  height: 30px;
  line-height: 25px;
  top: 0px;
}
.v-select__selection {
  height: 25px;
  line-height: 25px;
  margin: 0 !important;
}
.v-select__selection--comma {
  margin: 0 !important;
}
</style>
